module.exports = __webpack_public_path__ + "static/alan-2977b476bd13e66b6d7035c40e05166c.jpg";